export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd';
export const BACKEND_DATE_SHORT_FORMAT = 'yyyy-MM';
